/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { ChangeEvent } from 'react'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Select } from '@nexigendigital/nxui'
import { updateBillingCycle } from 'store/slices/shopSlice'
import { PendingItem, Pricing } from 'models/shop'
import { aud, getBillingCycle } from 'helpers/utils'
import { useAppDispatch } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    domainName: string,
    pricing: Pricing[],
    items: PendingItem[],
    addedItem: PendingItem | undefined
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function BillingCyclePricing({ id, domainName, pricing, items, addedItem }: Props) {
    const dispatch = useAppDispatch()
    const registrationPricing: any = pricing.filter(({ type }) => type === 'register')
    const currentItem = addedItem
        ? items.find((item: PendingItem) => item?.name === domainName && item?.product_id === id)
        : registrationPricing[0]

    return (
        <SelectWrapper>
            <Select
                disabled={!addedItem}
                value={currentItem.billing_cycle_id}
                onChange={(e: ChangeEvent<{ value: string }>) => {
                    const value = parseInt(e.target.value, 10)

                    dispatch(updateBillingCycle({
                        product_id: id,
                        name: domainName,
                        billing_cycle_id: value,
                        type: 'register'
                    }))
                }}
            >
                {registrationPricing.map((pricingList: Pricing) => {
                    return (
                        <option key={pricingList.billing_cycle_id} value={pricingList.billing_cycle_id}>
                            {aud(pricingList.price)}
                            {' '}
                            {pricingList.billing_cycle
                                ? getBillingCycle(pricingList.billing_cycle.name)
                                : `/${pricingList.billing_cycle_id}`
                            }
                        </option>
                    )
                })}
            </Select>
        </SelectWrapper>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const SelectWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`
